import { PluginManifest } from "./types"

export const BASE_PLUGIN_IDS = ["chat", "gradeai"] as const

export function getActivePluginIds(): string[] {
  const envValue = process.env.NEXT_PUBLIC_ACTIVE_PLUGINS || ""
  const fromEnv = envValue
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean)
  const unique = new Set<string>([...BASE_PLUGIN_IDS, ...fromEnv])
  return Array.from(unique)
}

export function isPluginEnabled(id: string): boolean {
  return getActivePluginIds().includes(id)
}

export function sortPlugins<T extends PluginManifest>(plugins: T[]): T[] {
  return [...plugins].sort((a, b) => {
    if (typeof a.order === "number" && typeof b.order === "number") {
      return a.order - b.order
    }
    if (typeof a.order === "number") return -1
    if (typeof b.order === "number") return 1
    return a.name.localeCompare(b.name)
  })
}

export function partitionPlugins<T extends PluginManifest>(plugins: T[]) {
  const enabled: T[] = []
  const comingSoon: T[] = []
  plugins.forEach((plugin) => {
    if (plugin.availability === "enabled") {
      enabled.push(plugin)
    } else {
      comingSoon.push(plugin)
    }
  })
  return { enabled, comingSoon }
}
